import { render, staticRenderFns } from "./RunnitModelsListPage.vue?vue&type=template&id=67e90c13&scoped=true"
import script from "./RunnitModelsListPage.vue?vue&type=script&lang=ts"
export * from "./RunnitModelsListPage.vue?vue&type=script&lang=ts"
import style0 from "./RunnitModelsListPage.vue?vue&type=style&index=0&id=67e90c13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e90c13",
  null
  
)

export default component.exports